module.exports = __webpack_public_path__ + "img/TECNOLOGIA-VITARA-5.510de689.jpg";